module.exports = __webpack_public_path__ + "static/media/backArrow.b2c36d66.svg";